const actions = {
  CHECK_AUTHORIZATION: "CHECK_AUTHORIZATION",
  LOGOUT: "LOGOUT",

  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",

  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  login: (user) => ({
    type: actions.LOGIN_REQUEST,
    payload: { user },
  }),

  logout: () => ({
    type: actions.LOGOUT,
  }),
};
export default actions;
